// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3-Od4","content":"Consent_content__1Ro4e","footer":"Consent_footer__1Neod"};